var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlexLayout',{attrs:{"role":"region"}},[(_vm.success)?_c('BlockContainer',[_c('p',[_vm._v(_vm._s(_vm.message))]),_c('Button',{attrs:{"variant":"primary"},on:{"click":_vm.navigateToLogin}},[_vm._v(_vm._s(_vm.$t('button.login')))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }